/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AlternatingCurrentType } from '../models/AlternatingCurrentType';
import type { PaginatedAlternatingCurrentTypeList } from '../models/PaginatedAlternatingCurrentTypeList';
import type { PatchedAlternatingCurrentType } from '../models/PatchedAlternatingCurrentType';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LeadsAlternatingCurrentTypesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedAlternatingCurrentTypeList
     * @throws ApiError
     */
    public leadsAlternatingCurrentTypesList({
        page,
        pageSize,
        search,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedAlternatingCurrentTypeList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-alternating-current-types/',
            query: {
                'page': page,
                'page_size': pageSize,
                'search': search,
            },
        });
    }

    /**
     * @returns AlternatingCurrentType
     * @throws ApiError
     */
    public leadsAlternatingCurrentTypesCreate({
        requestBody,
    }: {
        requestBody: AlternatingCurrentType,
    }): CancelablePromise<AlternatingCurrentType> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/leads-alternating-current-types/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AlternatingCurrentType
     * @throws ApiError
     */
    public leadsAlternatingCurrentTypesRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this alternating current type.
         */
        id: number,
    }): CancelablePromise<AlternatingCurrentType> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/leads-alternating-current-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns AlternatingCurrentType
     * @throws ApiError
     */
    public leadsAlternatingCurrentTypesUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this alternating current type.
         */
        id: number,
        requestBody: AlternatingCurrentType,
    }): CancelablePromise<AlternatingCurrentType> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/leads-alternating-current-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns AlternatingCurrentType
     * @throws ApiError
     */
    public leadsAlternatingCurrentTypesPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this alternating current type.
         */
        id: number,
        requestBody?: PatchedAlternatingCurrentType,
    }): CancelablePromise<AlternatingCurrentType> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/leads-alternating-current-types/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public leadsAlternatingCurrentTypesDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this alternating current type.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/leads-alternating-current-types/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
